<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Confira a lista de todas as startups participantes do due
              diligence. Você pode visualizar com detalhes as informações de
              cada startup, como o pitch vídeo e o deck de apresentação.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div v-if="!empty" class="card-deck vld-parent" ref="startups_list">
            <div
              class="col-lg-3 col-md-6 mb-5 d-flex align-items-stretch"
              v-for="startup in startups"
              :key="startup.user_id"
            >
              <div class="card text-center flex-grow-1">
                <div class="card-profile-image">
                  <img
                    :src="startup.logo.url"
                    class="card-image my-3"
                    alt="..."
                  />
                </div>
                <div class="card-body mt-7 pt-4 pt-0 pb-0">
                  <h2 class="card-title text-orange mb-1">
                    {{ startup.name }}
                  </h2>
                  <div>
                    <div class="h5 font-weight-300 mb-1">
                      <i class="ni ni-pin-3 mr-2"></i
                      >{{ startup.city || "..." }}, {{ startup.state || "..." }}
                    </div>
                    <div class="h5 mt-2">
                      <badge type="info">
                        {{ startup.sector }}
                      </badge>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-center">
                  <router-link
                    :to="`/investidor/due-diligences/${startup.due_diligence_id}/inscricoes/${startup.subscription_id}/visualizar`"
                    ><i class="fas fa-eye mr-1" title="Visualizar startup"></i>
                    Ver startup</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div v-else class="row">
            <div class="col-12 text-center">
              <badge type="info" class="bg-white">
                Nenhuma startup cadastrada no processo de due diligence até o
                momento.
              </badge>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "startups_list",
  data() {
    return {
      startups: [],
      empty: false,
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.startups_list,
      width: 150,
      height: 150,
      color: "#ffffff",
      backgroundColor: "transparent",
    });
    this.loadStartups();
    loader.hide();
  },
  methods: {
    async loadStartups() {
      try {
        const { data } = await api.get(
          `/investor-due-diligences/${this.$route.params.id}`
        );
        const defaultLogoPath = "/img/pages/default_logo.png";
        data.forEach((startup) => {
          if (!startup.logo) startup.logo = { url: defaultLogoPath };
        });
        if (data.length) this.startups = data;
        else this.empty = true;
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as startups do due diligence"
        );
        this.$router.push("/investidor/due-diligences");
      }
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 140px;
  height: 140px;
  border-radius: 10%;
  margin: auto;
}
</style>
